import { useMutation, UseMutationOptions } from "@tanstack/react-query";

import {
  NpsSubmitPayload,
  NpsTriggerPayload,
  NpsTriggerResponse
} from "@/types/nps";
import { CustomError } from "@/utils/errors";

import { postNpsResponse, postNpsTrigger } from "./npsApi";

export const usePostNpsTriggerMutation = (
  options?: UseMutationOptions<
    NpsTriggerResponse,
    { message: CustomError },
    NpsTriggerPayload
  >
) => {
  return useMutation({
    mutationFn: (payload: NpsTriggerPayload) => postNpsTrigger(payload),
    ...options
  });
};

export const usePostNpsResponseMutation = (
  options?: UseMutationOptions<
    unknown,
    { message: CustomError },
    { npsId: string; payload: NpsSubmitPayload }
  >
) => {
  return useMutation({
    mutationFn: ({
      npsId,
      payload
    }: {
      npsId: string;
      payload: NpsSubmitPayload;
    }) => postNpsResponse(npsId, payload),
    ...options
  });
};
